<template>
  <AddStudent update />
</template>
<script>
import appConfig from '@/app.config'
import AddStudent from '../../../components/skillup/students/AddStudent.vue'
export default {
  page: {
    title: 'ویرایش اطلاعات دانش پذیر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillup-edit-students',
  components: {
    AddStudent,
  },
}
</script>
